import { useQuery } from '@tanstack/react-query';
import { getStates } from 'services/get-states/get-states';

export const useStates = () => {
  return useQuery(['states'], {
    queryFn: getStates,
    staleTime: 10000,
  });
};
